// ./cmp/CategoryPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db1 } from "./firebase/firebase1";
import { collection, getDocs, query, where } from "firebase/firestore";

export default function CategoryPage() {
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);

  const [products, setProducts] = useState([])
  useEffect(() => {
    const loadProducts = async () => {
      try {
        setLoading(true)
        const q = query(
          collection(db1, "our_products"),
          where("category", "array-contains", slug)
        );
        const querySnapshot = await getDocs(q);
        const arr = [];
        querySnapshot.forEach((doc) => {
          arr.push({ id: doc.id, ...doc.data() })
        })
        // Optionally limit to first few
        setProducts(arr)
        setLoading(false)
      } catch (err) {
        console.error("Error fetching featured products:", err)
      }
    }
    loadProducts()
  }, [])

  // const [products, setProducts] = useState([]);
  // useEffect(() => {
  //   setLoading(true);
  //   const timer = setTimeout(() => {
  //     const list = PRODUCTS.filter((p) => p.category === slug);
  //     setProducts(list);
  //     setLoading(false);
  //     window.scrollTo(0, 0);
  //   }, 150);
  //   return () => clearTimeout(timer);
  // }, [slug]);

  const titleMap = {
    otc: "OTC Medicines",
    orthopedic: "Orthopedic Supports",
    wound: "Wound Care",
    mobility: "Mobility Aids",
    diagnostics: "Diagnostics",
    respiratory: "Respiratory",
    incontinence: "Incontinence",
    personal: "Personal Care",
    others: "Others",
  };

  const title = titleMap[slug] || slug;

  // helper: get numeric price (fallback to first variant)
  function getNumericPrice(item) {
    if (typeof item.price === "number") return item.price;
    const v = item.variants && item.variants[0];
    if (v && typeof v.price === "number") return v.price;
    return null;
  }

  return (
    <main style={{ width: "min(1100px, 94%)", margin: "28px auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h1 style={{ margin: 0 }}>{title}</h1>
        <div style={{ color: "#6b7280" }}>
          <Link to="/">Home</Link> / <strong>{title}</strong>
        </div>
      </div>

      <p style={{ color: "#6b7280", marginTop: 8 }}>
        Browse {title}. Click a product to view details and purchase options.
      </p>

      {loading ? (
        <div style={{ padding: 40 }}>Loading…</div>
      ) : products.length === 0 ? (
        <div style={{ padding: 40 }}>No products found in this category.</div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 16, marginTop: 16 }}>
          {products.map((p) => {
            const numPrice = getNumericPrice(p);
            return (
              <article key={p.id} style={{ border: "1px solid #eee", borderRadius: 12, overflow: "hidden", background: "white" }}>
                <Link to={`/product/${p.id}`} style={{ textDecoration: "none", color: "inherit", display: "block" }}>
                  <div style={{ height: 160, display: "flex", alignItems: "center", justifyContent: "center", background: "#fbfbfd" }}>
                    {p.images && p.images.length ? (
                      <img src={p.images[0]} alt={p.title} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
                    ) : p.image ? (
                      <img src={p.image} alt={p.title} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
                    ) : (
                      <div style={{ color: "#9ca3af" }}>No image</div>
                    )}
                  </div>

                  <div style={{ padding: 12 }}>
                    <div style={{ fontWeight: 700 }}>{p.title}</div>
                    <div style={{ color: "#6b7280", marginTop: 6 }}>{p.brand}</div>
                    <div style={{ marginTop: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: 800 }}>
                        ${p.price}
                      </div>
                      <div><button style={{ border: "none", background: "#0ea5e9", color: "white", padding: "8px 10px", borderRadius: 8, cursor: "pointer" }}>View</button></div>
                    </div>
                  </div>
                </Link>
              </article>
            );
          })}
        </div>
      )}
    </main>
  )
}
